import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import Modal from "react-bootstrap/Modal";
import { useNavigate } from "react-router-dom";
import { NavLink, Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import Pagination from "../General/Pagination";
import Monthly_navbar from "./Monthlytasks_navbar";
import { scrollToTop } from "../Shared/ScrollOnTop";

const ManageMonth = () => {
  const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID, setUserID] = useState(localStorage.getItem("ID"));
  const [MemberType, setMemberType] = useState(
    localStorage.getItem("MemberType")
  );
  const [loading, setLoading] = useState(false);
  const [listOfLedger, setLedger] = useState([]);
  const [isUpdated, setIsUpdated] = useState(false);

  // pagination
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);

  // change due date
  const [editMonth, setEditMonth] = useState(null);
  const [newDueDate, setNewDueDate] = useState("");
  const [savingDueDate, setSavingDueDate] = useState(false);

  const openDueDateModal = (item) => {
    setEditMonth(item);
    setNewDueDate(
      item.Challan_DueDate
        ? moment(item.Challan_DueDate).format(config.date_format_input)
        : ""
    );
  };

  const closeDueDateModal = () => {
    setEditMonth(null);
    setNewDueDate("");
  };

  const handleSaveDueDate = () => {
    if (!newDueDate) {
      toast.error("Please select a due date", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }

    setSavingDueDate(true);

    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      ID: editMonth.Month_ID,
      Challan_DueDate: newDueDate,
    };

    var api_config = {
      method: "post",
      url: config.base_url + "MonthlyTask/UpdateMonthDueDate",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(api_config)
      .then(function (response) {
        if (response.data.status_code == 1) {
          toast.success(response.data.status_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
          closeDueDateModal();
          setIsUpdated(true);
        } else {
          toast.error(response.data.status_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        setSavingDueDate(false);
      })
      .catch(function (error) {
        toast.error("Network Error..", {
          position: toast.POSITION.TOP_RIGHT,
        });
        setSavingDueDate(false);
      });
  };

  // Notes box on the Student Copy of the fee voucher (setting "ShowVoucherNotes", off by default)
  const [showVoucherNotes, setShowVoucherNotes] = useState(false);
  const [savingVoucherNotes, setSavingVoucherNotes] = useState(false);

  useEffect(() => {
    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      Name: "ShowVoucherNotes",
    };

    var api_config = {
      method: "post",
      url: config.base_url + "Setting/GetSettingByName",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(api_config)
      .then(function (response) {
        if (response.data.status_code == 1) {
          setShowVoucherNotes(response.data.IsOn === true);
        }
      })
      .catch(function (error) {
        ////console.log(error);
      });
  }, []);

  const handleToggleVoucherNotes = (e) => {
    const checked = e.target.checked;
    setSavingVoucherNotes(true);

    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      Name: "ShowVoucherNotes",
      Value: checked ? "1" : "0",
    };

    var api_config = {
      method: "post",
      url: config.base_url + "Setting/SaveSettingByName",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(api_config)
      .then(function (response) {
        if (response.data.status_code == 1) {
          setShowVoucherNotes(response.data.IsOn === true);
          toast.success(
            response.data.IsOn
              ? "Notes will now show on the Student Copy of fee vouchers"
              : "Notes are now hidden on the Student Copy of fee vouchers",
            {
              position: toast.POSITION.TOP_RIGHT,
            }
          );
        } else {
          toast.error(response.data.status_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        setSavingVoucherNotes(false);
      })
      .catch(function (error) {
        toast.error("Network Error..", {
          position: toast.POSITION.TOP_RIGHT,
        });
        setSavingVoucherNotes(false);
      });
  };

  useEffect(() => {
    document.title = "Manage Posted Fee";

    setIsUpdated(false);
    setLoading(true);

    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      pageNo: pageNo,
      pageSize: pageSize,
      SchoolID: 1,
    };

    var api_config = {
      method: "post",
      url: config.base_url + "MonthlyTask/GetStartedMonths",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(api_config)
      .then(function (response) {
        ////console.log(response.data);
        setLedger(response.data.ListofRecords);
        setLoading(false);
        setTotalRecords(response.data.totalRecords);
      })
      .catch(function (error) {
        ////console.log(error);
      });
  }, [pageNo, pageSize, isUpdated]);

  const handlePageChange = (page) => {
    setPageNo(page);
  };

  const renderLedger = () => {
    if (listOfLedger != null && listOfLedger.length > 0) {
      //console.log(listOfLedger)
      let count = 1;
      return listOfLedger.map((item, index) => {
        return (
          <tr key={index}>
            <td>{count++ + pageSize * (pageNo - 1)}</td>
            <td>{item.Month_ID}</td>
            <td>{item.Month_Number}</td>
            <td>{item.Current_Year}</td>
            <td style={{ maxWidth: "612px" }}>{item.Class_Name}</td>
            <td>{item.Total_Students}</td>
            <td >
              {moment(item.Started_On).format(config.date_format)}
            </td>
            <td className="text-nowrap">
              {item.Challan_DueDate
                ? moment(item.Challan_DueDate).format(config.date_format)
                : "-"}
            </td>
            <td>{item.User_Name}</td>
            <td className="text-center">
              <ul
                className="inline-action"
                aria-labelledby="dropdownMenuButton1"
              >
                <li>
                  <button
                    type="button"
                    className="green"
                    title="Change Due Date"
                    onClick={() => openDueDateModal(item)}
                  >
                    <i className="ri-calendar-event-line"></i>
                  </button>
                </li>

                <li>
                  <NavLink
                    to={
                      "/MonthlyTasks/MonthDetails/?Month=" +
                      item.Month_Number +
                      "&Year=" +
                      item.Current_Year +
                      "&ReferenceID=" + item.Month_ID
                    }
                    className="blue"
                  >
                    <i className="ri-pages-line"></i>
                  </NavLink>
                </li>
              </ul>

            </td>
          </tr>
        );
      });
    } else {
      return (
        <tr>
          <td colSpan="10">
            <h4
              className="mt-3"
              style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}
            >
              No Data Found
            </h4>
          </td>
        </tr>
      );
    }
  };

  return (
    <>
      <ToastContainer />
      <Monthly_navbar />
      <Modal show={editMonth != null} onHide={closeDueDateModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Change Due Date</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {editMonth && (
            <>
              <p className="mb-2">
                Posting Code: <strong>{editMonth.Month_ID}</strong> &nbsp;|&nbsp;
                Month:{" "}
                <strong>
                  {moment()
                    .month(editMonth.Month_Number - 1)
                    .format("MMMM")}{" "}
                  {editMonth.Current_Year}
                </strong>
              </p>
              <p className="mb-3">
                Current Due Date:{" "}
                <strong>
                  {editMonth.Challan_DueDate
                    ? moment(editMonth.Challan_DueDate).format("DD MMM YYYY")
                    : "Not set"}
                </strong>
              </p>
              <div className="form-group mb-3">
                <label>New Due Date:</label>
                <input
                  type="date"
                  className="form-control"
                  value={newDueDate}
                  onChange={(e) => setNewDueDate(e.target.value)}
                />
              </div>
              <p className="text-muted mb-0" style={{ fontSize: "13px" }}>
                Applies to every voucher of this posting printed from now on,
                and to the late fine charged on bank payments. Vouchers already
                printed keep the old date.
              </p>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="button button-white"
            onClick={closeDueDateModal}
            disabled={savingDueDate}
          >
            Cancel
          </button>
          <button
            type="button"
            className="button button-primary"
            onClick={handleSaveDueDate}
            disabled={savingDueDate}
          >
            {savingDueDate ? "Saving..." : "Save Due Date"}
          </button>
        </Modal.Footer>
      </Modal>
      <div className="page-head">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/MonthlyTasks/MonthlyTasksDashboard">
                      Fee Posting
                    </Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Manage Posted Fee
                  </li>
                </ol>
              </nav>
              <div className="page-title">Manage Posted Fee</div>
            </div>
            <div className="col-md-6">
              <div className="page-right-actions">
                <Link
                  to="/MonthlyTasks/StartNewMonth"
                  className="button button-white button-icon"
                >
                  Post Fee
                  <i className="ri-add-line"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="page-content">
        <div className="container">
          <div className="card mb-3">
            <div className="card-body">
              <div className="form-check form-switch mb-0">
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="showVoucherNotes"
                  checked={showVoucherNotes}
                  disabled={savingVoucherNotes}
                  onChange={handleToggleVoucherNotes}
                />
                <label className="form-check-label" htmlFor="showVoucherNotes">
                  Show Notes box on the Student Copy of fee vouchers
                </label>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-body">
              <div>
                <table className="table table-theme table-hover">
                  <thead>
                    <tr>
                      <th>Sr. No</th>
                      <th>Posting Code</th>
                      <th>Month</th>
                      <th>Year</th>
                      <th>Classes</th>
                      <th>Total Student</th>
                      <th >Started On</th>
                      <th>Due Date</th>
                      <th>User Name</th>
                      <th className="text-center">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td className="text-center" colSpan="10">
                          <Spinner animation="border" role="status"></Spinner>
                        </td>
                      </tr>
                    ) : (
                      <>{renderLedger()}</>
                    )}
                  </tbody>
                </table>
                {totalRecords > 3 && (
                  <div className="pagination-wrap">
                    <div className="row align-items-center">
                      <div className="col-md-2 form_default">
                        <div className="d-flex align-items-center">
                          <label className="me-2" style={{ fontSize: "15px" }}>
                            Page Size
                          </label>
                          <div className="form-group">
                            <select
                              className="form-select"
                              style={{ width: "100px" }}
                              onChange={(e) => {
                                setPageNo(1);
                                setPageSize(parseInt(e.target.value));
                              }}
                            >
                              <option value="10" selected>
                                10
                              </option>
                              <option value="20">20</option>
                              <option value="50">50</option>
                            </select>
                          </div>
                        </div>
                      </div>

                      <Pagination
                        pageNo={pageNo}
                        pageSize={pageSize}
                        totalRecords={totalRecords}
                        onPageChange={handlePageChange}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ManageMonth;
